@ -0,0 +1,42 @@
<template>
  <svg :style="style" width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="&#230;&#181;&#139;&#232;&#175;&#132;&#230;&#150;&#185;&#229;&#188;&#143;">
<g id="Frame" clip-path="url(#clip0_4386_91517)">
<path id="Vector" d="M12.6667 5.58333H10.3333V3.83333C10.3329 3.21464 10.0869 2.62143 9.64938 2.18395C9.2119 1.74647 8.61869 1.50048 8 1.5H3.33333C2.71464 1.50048 2.12143 1.74647 1.68395 2.18395C1.24647 2.62143 1.00048 3.21464 1 3.83333V13.1667C1.00048 13.7854 1.24647 14.3786 1.68395 14.816C2.12143 15.2535 2.71464 15.4995 3.33333 15.5H12.6667C13.2854 15.4995 13.8786 15.2535 14.316 14.816C14.7535 14.3786 14.9995 13.7854 15 13.1667V7.91667C14.9995 7.29798 14.7535 6.70476 14.316 6.26728C13.8786 5.8298 13.2854 5.58382 12.6667 5.58333ZM3.91667 14.3333V10.25C3.91715 9.94073 4.04022 9.64426 4.25891 9.42557C4.4776 9.20689 4.77406 9.08382 5.08333 9.08333H6.25C6.55927 9.08382 6.85574 9.20689 7.07443 9.42557C7.29311 9.64426 7.41618 9.94073 7.41667 10.25V14.3333H3.91667ZM4.5 6.16667C4.34529 6.16667 4.19692 6.10521 4.08752 5.99581C3.97812 5.88642 3.91667 5.73804 3.91667 5.58333C3.91667 5.42862 3.97812 5.28025 4.08752 5.17085C4.19692 5.06146 4.34529 5 4.5 5H5.08333V4.41667C5.08333 4.26196 5.14479 4.11358 5.25419 4.00419C5.36358 3.89479 5.51196 3.83333 5.66667 3.83333C5.82138 3.83333 5.96975 3.89479 6.07915 4.00419C6.18854 4.11358 6.25 4.26196 6.25 4.41667V5H6.83333C6.98804 5 7.13642 5.06146 7.24581 5.17085C7.35521 5.28025 7.41667 5.42862 7.41667 5.58333C7.41667 5.73804 7.35521 5.88642 7.24581 5.99581C7.13642 6.10521 6.98804 6.16667 6.83333 6.16667H6.25V6.75C6.25 6.90471 6.18854 7.05308 6.07915 7.16248C5.96975 7.27187 5.82138 7.33333 5.66667 7.33333C5.51196 7.33333 5.36358 7.27187 5.25419 7.16248C5.14479 7.05308 5.08333 6.90471 5.08333 6.75V6.16667H4.5ZM11.7917 12.5833C11.637 12.5833 11.4886 12.5219 11.3792 12.4125C11.2698 12.3031 11.2083 12.1547 11.2083 12C11.2083 11.8453 11.2698 11.6969 11.3792 11.5875C11.4886 11.4781 11.637 11.4167 11.7917 11.4167H12.375C12.5297 11.4167 12.6781 11.4781 12.7875 11.5875C12.8969 11.6969 12.9583 11.8453 12.9583 12C12.9583 12.1547 12.8969 12.3031 12.7875 12.4125C12.6781 12.5219 12.5297 12.5833 12.375 12.5833H11.7917ZM12.375 9.66667H11.7917C11.637 9.66667 11.4886 9.60521 11.3792 9.49581C11.2698 9.38642 11.2083 9.23804 11.2083 9.08333C11.2083 8.92862 11.2698 8.78025 11.3792 8.67085C11.4886 8.56146 11.637 8.5 11.7917 8.5H12.375C12.5297 8.5 12.6781 8.56146 12.7875 8.67085C12.8969 8.78025 12.9583 8.92862 12.9583 9.08333C12.9583 9.23804 12.8969 9.38642 12.7875 9.49581C12.6781 9.60521 12.5297 9.66667 12.375 9.66667Z" fill="white"/>
</g>
</g>
<defs>
<clipPath id="clip0_4386_91517">
<rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
  </svg>
</template>

<script>
export default {
  name: 'IconCity',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        'font-size': this.fontSize
      }
    }
  }
}
</script>